module.exports = function() {
  return new Worker(__webpack_public_path__ + "015affa4b6257f086d56.worker.js");
};